import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const CarIconBlue: FC<IconProps> = ({ width = 33, height = 16, ...rest }) => (
  <Icon type="CarBlue" width={width} height={height} alt="CarIconBlue" {...rest} />
)
